import React, { useContext, useMemo } from 'react';
const PusherContext = /*#__PURE__*/React.createContext(null);
export function PusherProvider(props) {
  const {
    children,
    pusher
  } = props; // We intentionally use the initial props.pusher that was provided on mount.
  // Please don't change pusher dynamically.

  const value = useMemo(() => pusher, []); // eslint-disable-line react-hooks-static-deps/exhaustive-deps

  return /*#__PURE__*/React.createElement(PusherContext.Provider, {
    value: value
  }, children);
}
export const usePusher = () => {
  return useContext(PusherContext);
};